<template>
  <div class="addresolution">
    <van-cell-group>
      <van-field
        v-model="width"
        type="number"
        :label="$t('append_field.width')"
        :placeholder="$t('append_field.enter_width')"
        required
        @blur="requiredW"
        :error-message="errorW"
      />
      <van-field
        v-model="height"
        required
        type="number"
        :label="$t('append_field.height')"
        :placeholder="$t('append_field.enter_height')"
        @blur="requiredH"
        :error-message="errorH"
      />
    </van-cell-group>
    <div style="height: 30px"></div>
    <van-button block size="small" color="#006EFF" @click="onsubmit">{{$t('append_field.add')}}</van-button>
  </div>
</template>

<script>
  import qs from 'qs'
  import { Toast } from 'vant'
  import $ from 'jquery'

  export default {
    name: 'addresolution',
    data() {
      return {
        height: '',
        width: '',
        errorH: '',
        errorW: '',
      }
    },
    mounted() {
      this.$nextTick(()=>{
        var winHeight = $(window).height()
        $(window).resize(function ()  {
          var thisWidth = $(this).height()
          if (winHeight > thisWidth) {
            $(".van-tabbar").hide()
          }else {
            $(".van-tabbar").show()
          }
        })
      })
    },
    methods: {
      removeLeadingZeros(num) {
        const str = String(num);
        const result = str.replace(/^0+/, '');
        return result === '' ? 0 : parseInt(result);
      },
      onsubmit() {
        const w = this.removeLeadingZeros(this.width)
        const h = this.removeLeadingZeros(this.height)
        if (!w || !h) {
          Toast(this.$t('append_field.height_width_cannot_be_empty'))
          return;
        }
        if (w <= 299 || w >= 8001) {
          Toast(this.$t('append_field.enter_number_between_300_to_8000'))
          return;
        }
        if (h <= 299 || h >= 8001) {
          Toast(this.$t('append_field.enter_number_between_300_to_8000'))
          return;
        }
        this.$ajax.post('/etv/insertResolution.json', qs.stringify({
          ruLPixel: w,
          ruWPixel: h,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.add_success'))
            this.$router.push('/newprogram')
          } else {
            Toast(res.data.msg)
          }
        })
      },
      requiredW() {
        if (this.width === '' || parseInt(this.width) <= 299 || parseInt(this.width) >= 8001) {
          this.errorW = this.$t('append_field.enter_number_between_300_to_8000')
        } else {
          this.errorW = ''
        }
      },
      requiredH() {
        if (parseInt(this.height) <= 299 || parseInt(this.height) >= 8001) {
          this.errorH = this.$t('append_field.enter_number_between_300_to_8000')
        } else {
          this.errorH = ''
        }
      },
    },
  }
</script>

<style scoped>
  .addresolution {
    padding: 10px;
    box-sizing: border-box;
  }
</style>
